(function () {
  'use strict';
  if (window.__bbCartExtrasInit) return;
  window.__bbCartExtrasInit = true;
  /* BB_CART_EXTRAS_JS_20261021 — Brick Blaster cart drawer extras (markup: snippets/bb-cart-extras.liquid).
     1. Add-on carousel: 3 per slide, native swipe (scroll snap) + arrows. "Add" puts one unit in the cart through
        /cart/add.js and re-renders the drawer with the theme's own renderContents (same pattern as bb-cart.js).
     2. Kits: the Brick Blasters go through the PDP pack path, window.BrickOfferTests.addPack (same mutex, same
        tier/arm rules as the Buy 1 / 2 / 3 bars), plus N x gear pack. Nothing else is added or removed here.
     3. App row (BB_APP_SUB_20261022, pre-checked): expands on tap. With a real product in a USD cart the app line
        (checkbox variant + selling plan) is added by itself unless the shopper unticked it for this cart (cart
        attribute _bb_app_optout = 1); without a real product it is removed and the row hides. Lines go by exact line key.
     It never sets or computes a price: every amount on screen is a Liquid money string. Cart writes are
     serialized behind BrickOfferTests.exclusive when the offer runtime is on the page. */

  var ADD_LABEL_BUSY = 'Adding…', ADD_LABEL_ERROR = 'Try again';
  var subOpen = false, painting = false;

  function drawer() { return document.querySelector('cart-drawer'); }
  function num(v) { var n = Number(v); return isFinite(n) ? n : 0; }
  function route(name, fallback) { return ((window.routes && window.routes[name]) || fallback); }
  function bridge() { return window.BrickOfferTests || null; }
  function serial(work) { var b = bridge(); return b && typeof b.exclusive === 'function' ? b.exclusive(work) : Promise.resolve().then(work); }
  function announce() { try { document.dispatchEvent(new CustomEvent('bb:cart:changed', { detail: { source: 'bb-cart-extras' } })); } catch (e) {} }

  function post(url, body, signal) {
    body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname;
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body), signal: signal })
      .then(function (r) { return r.json().then(function (data) { if (!r.ok || data.status) throw new Error('cart-' + r.status); return data; }); });
  }
  /* Theme contract, as bb-cart.js render(): swap the drawer through renderContents, never replace <cart-drawer>. */
  function render(data) {
    var cd = drawer();
    if (!cd || !data || !data.sections || !data.sections['cart-drawer'] || typeof cd.renderContents !== 'function') return false;
    cd.renderContents(data, true);
    cd.classList.remove('is-empty');
    return true;
  }
  function refreshFromServer() {
    var b = bridge();
    if (b && typeof b.refresh === 'function') return b.refresh();
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('sections-' + r.status); return r.json(); })
      .then(function (sections) { render({ sections: sections }); });
  }
  function afterWrite(data) {
    /* The full cart page has its own table: reload it, like bb-cart.js afterWrite(). */
    if (document.querySelector('cart-items')) { window.location.reload(); return Promise.resolve(); }
    if (render(data)) return Promise.resolve();
    return Promise.resolve(refreshFromServer()).catch(function () {});
  }

  function setBusy(btn, state) {
    if (!btn) return;
    if (!btn.__bbxLabel) btn.__bbxLabel = btn.textContent;
    if (state === 'busy') { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = ADD_LABEL_BUSY; return; }
    btn.removeAttribute('aria-busy'); btn.disabled = false;
    btn.textContent = state === 'error' ? ADD_LABEL_ERROR : btn.__bbxLabel;
  }

  /* ---------- 1. add-ons ---------- */
  function addAddon(btn) {
    /* an add-on with options (e.g. holster side) carries a small select; its default is the first available */
    var row = btn.closest('[data-bbx-addon]'), pick = row && row.querySelector('[data-bbx-addon-variant]');
    var id = num(pick ? pick.value : btn.getAttribute('data-bbx-add'));
    if (!id || btn.disabled) return;
    setBusy(btn, 'busy');
    var added = false;
    serial(function () { return post(route('cart_add_url', '/cart/add') + '.js', { items: [{ id: id, quantity: 1 }] }); })
      .then(function (data) { added = true; return afterWrite(data); })
      .then(function () { announce(); if (document.body.contains(btn)) setBusy(btn, 'idle'); })
      .catch(function () { if (added) { announce(); setBusy(btn, 'idle'); } else setBusy(btn, 'error'); });
  }

  /* ---------- 2. kits ---------- */
  /* Pack lines exactly as bb-pdp.js packItems() builds them for this tier (gift line, then the blasters),
     without the drawer toggles; the offer runtime adapts them to the visitor's arm (preparePack). */
  function kitItems(card) {
    var tier = num(card.getAttribute('data-bbx-tier')), blasters = num(card.getAttribute('data-bbx-blasters'));
    var gear = num(card.getAttribute('data-bbx-gear')), mini = num(card.getAttribute('data-bbx-mini'));
    var select = card.querySelector('[data-bbx-kit-color]'), color = select ? num(select.value) : 0;
    if (!tier || !blasters || !gear || !color) return null;
    var items = [{ id: gear, quantity: tier }];
    if (mini > 0) items.push({ id: mini, quantity: 1, properties: { _bb_gift: '1' } });
    items.push({ id: color, quantity: blasters });
    return items;
  }
  function heroUnits(cart, heroId) {
    return (cart.items || []).reduce(function (n, item) { return n + (String(item.product_id) === String(heroId) ? num(item.quantity) : 0); }, 0);
  }
  /* Kit 3 = the Buy 3 bar: 4 blasters, 1 free. The free blaster counts once per order (control), so with 4+
     blasters already in the cart kit 3 adds 3: the cart total never rises by more than the card shows. */
  function checkFreeBlaster(card, items) {
    if (num(card.getAttribute('data-bbx-tier')) !== 3 || num(card.getAttribute('data-bbx-blasters')) !== 4 || arm() !== 'control') return Promise.resolve(items);
    return fetch(route('cart_url', '/cart') + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart-read'); return r.json(); })
      .then(function (cart) { if (heroUnits(cart, card.getAttribute('data-bbx-hero')) >= 4) items[items.length - 1].quantity = 3; return items; })
      .catch(function () { return items; });
  }
  function addKit(btn) {
    var card = btn.closest('[data-bbx-kit]'); if (!card || btn.disabled) return;
    var items = kitItems(card); if (!items) return;
    setBusy(btn, 'busy');
    var b = bridge(), added = false;
    var op = checkFreeBlaster(card, items).then(function (ready) {
      return (b && typeof b.addPack === 'function')
        ? b.addPack(ready, card)
        : serial(function () { return post(route('cart_add_url', '/cart/add') + '.js', { items: ready }); });
    });
    /* Once the kit is in the cart a refresh failure must never offer "Try again": a re-tap would add it twice. */
    op.then(function (data) { added = true; return afterWrite(data || {}); })
      .then(function () { announce(); if (document.body.contains(btn)) setBusy(btn, 'idle'); })
      .catch(function () { if (added) { announce(); setBusy(btn, 'idle'); } else setBusy(btn, 'error'); });
  }
  function setText(el, text) { if (el && el.textContent !== text) el.textContent = text; }
  function setHidden(el, on) { if (el && el.hidden !== on) el.hidden = on; }
  function onKitColor(select) {
    var card = select.closest('[data-bbx-kit]'); if (!card) return;
    var option = select.options[select.selectedIndex]; if (!option) return;
    var img = card.querySelector('[data-bbx-kit-img]'), src = option.getAttribute('data-img');
    if (img && src && img.getAttribute('src') !== src) img.setAttribute('src', src);
    var pay = option.getAttribute('data-pay') || '', was = option.getAttribute('data-was') || '', wasG = option.getAttribute('data-was-g') || '';
    if (pay) setText(card.querySelector('[data-bbx-kit-pay]'), pay);
    var w = card.querySelector('[data-bbx-kit-was]'); setText(w, was); setHidden(w, !was);
    var g = card.querySelector('[data-bbx-kit-was-g]'); setText(g, wasG); setHidden(g, !wasG);
  }

  /* ---------- 3. app subscription row ---------- */
  function paintSub(scope) {
    [].slice.call(scope.querySelectorAll('[data-bbx-sub]')).forEach(function (row) {
      var toggle = row.querySelector('[data-bbx-sub-toggle]'), body = row.querySelector('[data-bbx-sub-body]');
      if (toggle && toggle.getAttribute('aria-expanded') !== String(subOpen)) toggle.setAttribute('aria-expanded', String(subOpen));
      setHidden(body, !subOpen);
    });
  }
  var SUB_OPTOUT = '_bb_app_optout', SUB_FAILS = 'bbAppSubFails';
  var subTimer = null, subLastRun = 0, subPending = 0, subVersion = 0, subIntent = null;
  if (window.BBAppCheckout && typeof window.BBAppCheckout.choice === 'boolean') {
    subIntent = window.BBAppCheckout.choice; subVersion += 1;
    window.BBAppCheckout.choice = null;
  }
  var subQueue = Promise.resolve(), subLatest = subQueue;
  function subIds() {
    /* Configuration survives non-USD/empty renders independently of the visible checkbox. */
    var el = document.querySelector('[data-bb-cart-config]');
    if (!el) return null;
    var cfg = JSON.parse(el.textContent || '{}');
    if (!cfg.subscriptionEnabled) return null;
    var ids = { variant: num(cfg.subscriptionVariant), plan: num(cfg.subscriptionPlan), on: cfg.subscriptionDefaultOn === true, active: cfg.subscriptionActiveCustomer === true };
    if (!ids.variant || !ids.plan) throw new Error('app-config');
    return ids;
  }
  function readCart(signal) {
    return fetch(route('cart_url', '/cart') + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: signal })
      .then(function (r) { if (!r.ok) throw new Error('cart-read'); return r.json(); });
  }
  function subRequest(work) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null, timer;
    /* Abort a stalled request and fail closed; an expired checkout is never resumed by a late response. */
    return new Promise(function (resolve, reject) {
      timer = window.setTimeout(function () { if (controller) controller.abort(); reject(new Error('app-request-timeout')); }, 7000);
      Promise.resolve().then(function () { return work(controller ? controller.signal : undefined); }).then(resolve, reject);
    }).then(function (data) { window.clearTimeout(timer); return data; }, function (error) { window.clearTimeout(timer); throw error; });
  }
  function subRead() { return subRequest(function (signal) { return readCart(signal); }); }
  function subPost(name, fallback, body) { return subRequest(function (signal) { return post(route(name, fallback) + '.js', body, signal); }); }
  function subError(text) {
    if (window.BBAppCheckout) window.BBAppCheckout.error(text);
    else { var el = document.querySelector('[data-bbx-sub-error]'); if (el) { setText(el, text); setHidden(el, !text); } }
  }
  function fails(add) {
    try { var n = num(window.sessionStorage.getItem(SUB_FAILS)); if (add) window.sessionStorage.setItem(SUB_FAILS, String(n + 1)); return n + (add ? 1 : 0); } catch (e) { return 0; }
  }
  /* Real = anything the shopper buys: not the app line, not a gift line (_bb_gift / _bos_gift), not a drawer toggle
     (gift wrap, shipping protection: same list as snippets/bb-cart-extras.liquid). */
  function subState(cart, ids) {
    var toggles = ['yes-wrap-my-order-as-a-gift', 'shipping-protection'].concat([].slice.call(document.querySelectorAll('cart-drawer cart-drawer-upsell[data-toggle="true"]')).map(function (u) { return String(u.dataset.handle || ''); }));
    var real = 0, lines = [];
    (cart.items || []).forEach(function (item) {
      if (num(item.variant_id) === ids.variant) { lines.push(item); return; }
      var p = item.properties || {};
      if ((p._bb_gift != null && String(p._bb_gift) !== '') || (p._bos_gift != null && String(p._bos_gift) !== '')) return;
      if (toggles.indexOf(String(item.handle || '')) >= 0) return;
      real += 1;
    });
    var optout = !!(cart.attributes && String(cart.attributes[SUB_OPTOUT] || '') === '1');
    var usd = String(cart.currency || '').toUpperCase() === 'USD';
    var keep = real > 0 && usd && !optout && !ids.active, updates = {};
    lines.forEach(function (line, i) {
      if (!line.key) return;
      var plan = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan;
      if (!keep || i > 0 || !plan || num(plan.id) !== ids.plan) updates[line.key] = 0;
      else if (num(line.quantity) !== 1) updates[line.key] = 1;
    });
    var kept = lines.some(function (line) { return line.key && (!Object.prototype.hasOwnProperty.call(updates, line.key) || updates[line.key] > 0); });
    return { updates: updates, add: keep && ids.on && !kept, kept: kept, lines: lines, real: real };
  }
  /* No toy, no app row: the app only comes with a real product, so an unticked row is never left untickable. */
  function showSub(real) {
    [].slice.call(document.querySelectorAll('[data-bbx-sub]')).forEach(function (row) { setHidden(row, !real); });
  }
  function syncBox(checked) {
    var box = document.querySelector('[data-bbx-sub-opt]'), ids = subIds();
    if (!box) return;
    if (ids && ids.active) { box.checked = false; box.disabled = true; return; }
    if (box.checked !== checked) box.checked = checked;
    if (!subPending) box.disabled = false;
  }
  /* One subscription queue, one shared mutex acquisition per operation. Never call exclusive inside exclusive. */
  function writeSub(ids) {
    var version = subVersion, intent = subIntent, wrote = null;
    var policy = { variant: ids.variant, plan: ids.plan, active: ids.active, on: intent === true || ids.on };
    return subRead().then(function (cart) {
      var attributes = null;
      if (intent !== null && !ids.active) {
        var value = intent ? '' : '1';
        if (String((cart.attributes || {})[SUB_OPTOUT] || '') !== value) attributes = { _bb_app_optout: value };
        cart.attributes = Object.assign({}, cart.attributes || {}, { _bb_app_optout: value });
      }
      var state = subState(cart, policy), work = Promise.resolve();
      if (state.add && intent === null && fails(false) >= 2) throw new Error('app-add-limit');
      if (attributes || Object.keys(state.updates).length) {
        var body = { updates: state.updates };
        if (attributes) body.attributes = attributes;
        work = work.then(function () { return subPost('cart_update_url', '/cart/update', body).then(function (data) { wrote = data; }); });
      }
      if (state.add) {
        work = work.then(function () {
          return subPost('cart_add_url', '/cart/add', { items: [{ id: ids.variant, quantity: 1, selling_plan: ids.plan }] })
            .then(function (data) { wrote = data; }, function (error) { fails(true); throw error; });
        });
      }
      return work.then(function () { return wrote ? subRead() : cart; });
    }).then(function (cart) {
      var state = subState(cart, policy);
      var malformed = state.lines.some(function (line) {
        var plan = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan;
        return !line.key || num(line.quantity) !== 1 || !plan || num(plan.id) !== ids.plan;
      });
      if (state.add || Object.keys(state.updates).length || malformed || state.lines.length > 1) throw new Error('app-unconfirmed');
      if (intent === false && !ids.active && String((cart.attributes || {})[SUB_OPTOUT] || '') !== '1') throw new Error('app-optout-unconfirmed');
      if (subVersion === version) { subIntent = null; syncBox(state.kept); }
      return { cart: cart, wrote: wrote };
    });
  }
  function enqueueSub() {
    subPending += 1;
    var task = subQueue.then(function () {
      var ids = subIds();
      if (!ids) return null;
      subLastRun = Date.now();
      return serial(function () { return writeSub(ids); });
    }).then(function (result) {
      if (!result || !result.wrote) return result;
      return Promise.resolve(afterWrite(result.wrote)).then(function () { announce(); return result; });
    });
    subLatest = task.then(function (result) {
      subPending -= 1;
      if (!subPending) {
        var box = document.querySelector('[data-bbx-sub-opt]'), ids = subIds(), state = result && ids ? subState(result.cart, ids) : null;
        syncBox(subIntent === null ? !!(state && state.kept) : subIntent);
        if (state) showSub(state.real);
        if (box && !ids) box.disabled = false;
      }
      subError('');
      return result;
    }, function (error) {
      subPending -= 1;
      var box = document.querySelector('[data-bbx-sub-opt]');
      if (box) { box.disabled = false; if (subIntent !== null) box.checked = subIntent; }
      syncBox(box ? box.checked : false);
      subError('Couldn’t update the cart. Try checkout again.');
      throw error;
    });
    subQueue = subLatest.catch(function () {});
    return subLatest;
  }
  /* The one writer for the pre-checked default. Serialized with the offer runtime; one run at a time. */
  function reconcileSub() {
    if (subPending) return;
    try { if (!subIds()) return; } catch (error) { subError('Couldn’t update the cart. Try checkout again.'); return; }
    enqueueSub().catch(function () {});
  }
  function scheduleSub() {
    if (subTimer) return;
    var wait = Math.max(300, 1200 - (Date.now() - subLastRun));
    subTimer = window.setTimeout(function () { subTimer = null; reconcileSub(); }, wait);
  }
  function clearSubTimer() { if (subTimer) window.clearTimeout(subTimer); subTimer = null; }
  /* The shopper's tick: untick = remove the line by key and stamp the opt-out in ONE update; tick = clear it, add the line. */
  function onSubChange(box) {
    var ids;
    try { ids = subIds(); } catch (error) { box.checked = false; subError('Couldn’t update the cart. Try checkout again.'); return; }
    if (!ids || ids.active) { box.checked = false; if (ids && ids.active) box.disabled = true; return; }
    subIntent = box.checked; subVersion += 1;
    box.disabled = true; clearSubTimer();
    enqueueSub().catch(function () {});
  }
  /* Our own add-on never blocks the toy. After any checkout-decision failure one fresh authoritative cart read
     decides: continue with no app line, or with exactly one valid line (qty 1, configured plan, key) that the policy
     keeps and the shopper did not untick. Anything else (unwanted, duplicate or malformed line) stays blocked. */
  function subCheckoutOk(cart) {
    var ids = subIds();
    if (!ids) return true;
    var state = subState(cart, ids);
    if (!state.lines.length) return true;
    var line = state.lines[0], plan = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan;
    if (state.lines.length > 1 || !line.key || num(line.quantity) !== 1 || !plan || num(plan.id) !== ids.plan) return false;
    return subIntent !== false && state.kept && !Object.keys(state.updates).length;
  }
  function prepareCheckout() {
    clearSubTimer();
    var current = subPending ? subLatest : Promise.resolve();
    function settle() {
      clearSubTimer();
      var version = subVersion;
      return enqueueSub().then(function () {
        if (subPending || subVersion !== version) return subQueue.then(settle);
        clearSubTimer();
      });
    }
    return current.then(settle).catch(function (error) {
      /* A failed fresh read keeps the checkout blocked; the guard never resumes after its own deadline. */
      return serial(function () { return subRead(); }).then(function (cart) {
        if (!subCheckoutOk(cart)) throw error;
        subError('');
      });
    });
  }
  if (window.BBAppCheckout) window.BBAppCheckout.install(prepareCheckout);

  /* ---------- carousel ---------- */
  function paintArrows(root) {
    var track = root.querySelector('[data-bbx-track]'); if (!track) return;
    var prev = root.querySelector('[data-bbx-prev]'), next = root.querySelector('[data-bbx-next]');
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev && prev.disabled !== (track.scrollLeft <= 2)) prev.disabled = track.scrollLeft <= 2;
    if (next && next.disabled !== (track.scrollLeft >= max)) next.disabled = track.scrollLeft >= max;
  }
  function slide(btn, dir) {
    var root = btn.closest('[data-bbx-carousel]'), track = root && root.querySelector('[data-bbx-track]');
    if (!track) return;
    var to = track.scrollLeft + dir * track.clientWidth;
    try { track.scrollTo({ left: to, behavior: 'smooth' }); } catch (e) { track.scrollLeft = to; }
    window.setTimeout(function () { paintArrows(root); }, 400);
  }

  /* ---------- paint: arm text, app row state, arrows (attribute writes only, idempotent) ---------- */
  function arm() { try { var b = bridge(); return b && typeof b.treatment === 'function' && b.treatment() ? 'gifts' : 'control'; } catch (e) { return 'control'; } }
  function paint() {
    if (painting) return;
    painting = true;
    try {
      var state = arm();
      [].slice.call(document.querySelectorAll('[data-bbx]')).forEach(function (root) {
        if (root.getAttribute('data-bbx-arm-state') !== state) root.setAttribute('data-bbx-arm-state', state);
        paintSub(root);
        [].slice.call(root.querySelectorAll('[data-bbx-carousel]')).forEach(paintArrows);
      });
      if (subIds()) scheduleSub();
    } catch (e) {} finally { painting = false; }
  }
  var frame = null;
  function schedulePaint() {
    if (frame) return;
    var run = function () { frame = null; paint(); };
    frame = window.requestAnimationFrame ? window.requestAnimationFrame(run) : window.setTimeout(run, 16);
  }

  /* ---------- wiring: delegated, so every re-rendered drawer works without re-binding ---------- */
  document.addEventListener('click', function (event) {
    var t = event.target; if (!t || !t.closest) return;
    var btn = t.closest('[data-bbx-add]');
    if (btn) { event.preventDefault(); addAddon(btn); return; }
    btn = t.closest('[data-bbx-kit-add]');
    if (btn) { event.preventDefault(); addKit(btn); return; }
    btn = t.closest('[data-bbx-prev]');
    if (btn) { event.preventDefault(); slide(btn, -1); return; }
    btn = t.closest('[data-bbx-next]');
    if (btn) { event.preventDefault(); slide(btn, 1); return; }
    btn = t.closest('[data-bbx-sub-toggle]');
    if (btn) { event.preventDefault(); subOpen = !subOpen; paintSub(btn.closest('[data-bbx]') || document); }
  });
  function onAddonVariant(select) {
    var row = select.closest('[data-bbx-addon]'), option = select.options[select.selectedIndex];
    if (!row || !option) return;
    var pay = option.getAttribute('data-pay') || '', was = option.getAttribute('data-was') || '';
    if (pay) setText(row.querySelector('[data-bbx-addon-pay]'), pay);
    var w = row.querySelector('[data-bbx-addon-was]'); setText(w, was); setHidden(w, !was);
  }
  document.addEventListener('change', function (event) {
    var t = event.target; if (!t || !t.matches) return;
    if (t.matches('[data-bbx-kit-color]')) { onKitColor(t); return; }
    if (t.matches('[data-bbx-addon-variant]')) { onAddonVariant(t); return; }
    if (t.matches('[data-bbx-sub-opt]')) onSubChange(t);
  });
  /* scroll does not bubble: listen in the capture phase for the carousel track */
  document.addEventListener('scroll', function (event) {
    var t = event.target;
    if (t && t.matches && t.matches('[data-bbx-track]')) { var root = t.closest('[data-bbx-carousel]'); if (root) paintArrows(root); }
  }, true);

  function start() {
    var cd = drawer();
    if (cd && !cd.__bbxObserved) {
      cd.__bbxObserved = true;
      /* the theme swaps the drawer markup on every cart change; the class attribute flips when it opens */
      try { new MutationObserver(schedulePaint).observe(cd, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] }); } catch (e) {}
    }
    paint();
    /* the offer runtime learns the visitor's arm shortly after load */
    window.setTimeout(paint, 1200); window.setTimeout(paint, 3500);
  }
  ['bb:cart:changed', 'cartQuantityUpdated', 'cart:updated', 'cart:refresh'].forEach(function (name) { document.addEventListener(name, schedulePaint); });
  window.addEventListener('pageshow', schedulePaint);
  window.addEventListener('resize', schedulePaint);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
